/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Markers_Export_IdInputs */

const en_markers_export_id = /** @type {(inputs: Markers_Export_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Id`)
};

const fr_markers_export_id = /** @type {(inputs: Markers_Export_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID`)
};

const de_markers_export_id = /** @type {(inputs: Markers_Export_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausweis`)
};

const it_markers_export_id = /** @type {(inputs: Markers_Export_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Id`)
};

const ru_markers_export_id = /** @type {(inputs: Markers_Export_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Идентификатор`)
};

const es_markers_export_id = /** @type {(inputs: Markers_Export_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Identificación`)
};

const zh_cn2_markers_export_id = /** @type {(inputs: Markers_Export_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID`)
};

const ja_markers_export_id = /** @type {(inputs: Markers_Export_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID`)
};

const hi_markers_export_id = /** @type {(inputs: Markers_Export_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पहचान`)
};

const pt_pt2_markers_export_id = /** @type {(inputs: Markers_Export_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eu ia`)
};

/**
* | output |
* | --- |
* | "Id" |
*
* @param {Markers_Export_IdInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const markers_export_id = /** @type {((inputs?: Markers_Export_IdInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Markers_Export_IdInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_markers_export_id(inputs)
	if (locale === "de") return de_markers_export_id(inputs)
	if (locale === "it") return it_markers_export_id(inputs)
	if (locale === "ru") return ru_markers_export_id(inputs)
	if (locale === "es") return es_markers_export_id(inputs)
	if (locale === "zh-CN") return zh_cn2_markers_export_id(inputs)
	if (locale === "ja") return ja_markers_export_id(inputs)
	if (locale === "hi") return hi_markers_export_id(inputs)
	if (locale === "pt-PT") return pt_pt2_markers_export_id(inputs)
	return en_markers_export_id(inputs)
});